module.exports = __webpack_public_path__ + "img/shipo-sales-plan-icon-detail.4a5659c5.svg";